import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { AboutSpreadGroupTeaserItem } from '@/types/amplience';
import DynamicIcon, { ICON_MAP, isDynamicIcon } from '@/components/Common/DynamicIcon';
import { AmplienceResponsiveImage } from '@/components/ResponsiveImage/AmplienceResponsiveImage';
import AmplienceLink from '../Common/AmplienceLink';
const getImageShapeClass = (shape: 'circle' | 'roundedSquare' | 'square') => {
  switch (shape) {
    case 'circle':
      return 'rounded-full';
    case 'roundedSquare':
      return 'rounded-br-[8rem] md:rounded-br-[10rem]';
    case 'square':
    default:
      return 'rounded-3xl';
  }
};
const LOGO_ICONS_MAP: Record<AboutSpreadGroupTeaserItem['logo'], keyof typeof ICON_MAP> = {
  spreadshirt: 'spreadshirtLogo',
  spreadshirtpro: 'spreadshirtProLogo',
  spreadgroup: 'spreadgroupLogo',
  spreadlive: 'spreadliveLogo',
  teamshirts: 'teamshirtsLogo',
  spreadshop: 'spreadshopLogo',
  spreadconnect: 'spreadConnectLogo',
  spread: 'spreadLogo'
};
const IMAGE_WIDTHS = [200, 300, 400, 500, 600];
const ModuleItem: React.FC<{
  item: AboutSpreadGroupTeaserItem;
  textColorClass: string;
  imageSizes?: string;
}> = t0 => {
  const $ = _c(37);
  const {
    item,
    textColorClass,
    imageSizes: t1
  } = t0;
  const imageSizes = t1 === undefined ? "100vw" : t1;
  const {
    image,
    logo,
    imageShape,
    cta,
    paragraph
  } = item;
  let t2;
  if ($[0] !== imageShape) {
    t2 = clsx("relative mb-6 aspect-square w-full overflow-hidden bg-gray-200 md:mb-8", getImageShapeClass(imageShape));
    $[0] = imageShape;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== image.image || $[3] !== imageSizes) {
    t3 = {
      src: image.image,
      sizes: imageSizes,
      widths: IMAGE_WIDTHS
    };
    $[2] = image.image;
    $[3] = imageSizes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = image.altText ?? "";
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <AmplienceResponsiveImage source={t3} loading="lazy" alt={t4} className="absolute top-0 left-0 size-full object-cover" />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className={t2}>{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = LOGO_ICONS_MAP[logo];
  let t8;
  if ($[11] !== t7) {
    t8 = <DynamicIcon icon={t7} className="h-6 w-auto lg:h-10" />;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8 || $[14] !== textColorClass) {
    t9 = <div className="mb-4 flex w-full items-center"><div className={textColorClass}>{t8}</div></div>;
    $[13] = t8;
    $[14] = textColorClass;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== textColorClass) {
    t10 = clsx("md:text-md w-full text-sm lg:text-base", textColorClass);
    $[16] = textColorClass;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== paragraph || $[19] !== t10) {
    t11 = <p className={t10}>{paragraph}</p>;
    $[18] = paragraph;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== textColorClass) {
    t12 = clsx("md:text-md mt-4 inline-flex items-center gap-2 text-sm font-semibold hover:text-neutral-700 lg:text-base", textColorClass);
    $[21] = textColorClass;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== cta.label) {
    t13 = <span>{cta.label}</span>;
    $[23] = cta.label;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = isDynamicIcon(cta.icon) ? cta.icon : "arrowRight";
  let t15;
  if ($[25] !== t14) {
    t15 = <DynamicIcon icon={t14} className="size-4" />;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== cta || $[28] !== t12 || $[29] !== t13 || $[30] !== t15) {
    t16 = <AmplienceLink link={cta} className={t12}>{t13}{t15}</AmplienceLink>;
    $[27] = cta;
    $[28] = t12;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t11 || $[33] !== t16 || $[34] !== t6 || $[35] !== t9) {
    t17 = <div className="flex w-full flex-col"><div className="flex flex-col justify-start">{t6}{t9}{t11}{t16}</div></div>;
    $[32] = t11;
    $[33] = t16;
    $[34] = t6;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
};
export default ModuleItem;